/** @format */

export const NotificatoinLarge = ({color}) => {
    return (
        <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M13.3467 28.0133C13.3467 29.48 14.5333 30.6667 16 30.6667C17.4667 30.6667 18.6533 29.48 18.6533 28.0133H13.3467ZM16 8C19.68 8 22.6667 10.9867 22.6667 14.6667V24H9.33333V14.6667C9.33333 10.9867 12.32 8 16 8ZM16 2C14.8933 2 14 2.89333 14 4V5.56C9.81333 6.46667 6.66667 10.2 6.66667 14.6667V22.6667L4 25.3333V26.6667H28V25.3333L25.3333 22.6667V14.6667C25.3333 10.2 22.1867 6.46667 18 5.56V4C18 2.89333 17.1067 2 16 2Z"
                fill={color}
            />
        </svg>
    );
};
